import React, { FC } from "react";
import { Control } from "react-hook-form";
import { DoubleMaterialityStakeholderType } from "@green0meter/api-client";
import { t } from "i18next";

import { StakeholderFormValues } from "../StakeholdersEditor";

import {
  Typography,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@components/base";
import LabeledControllerField from "@components/common/LabeledControllerField/LabeledControllerField";

interface StakeholderTypeField {
  control: Control<StakeholderFormValues, Record<string, unknown>, unknown>;
  disabled?: boolean;
}

const StakeholderTypeField: FC<StakeholderTypeField> = ({
  control,
  disabled = false,
}) => (
  <LabeledControllerField
    label={t("stakeholders.fields.typeLabel", "Stakeholder type")}
    name={"type"}
    control={control}
    disabled={disabled}
    render={({ field, error, disabled }) => (
      <FormControl error={Boolean(error)}>
        <RadioGroup {...field} row>
          <FormControlLabel
            value={DoubleMaterialityStakeholderType.Internal}
            control={<Radio disabled={disabled} />}
            label={t("stakeholders.fields.type.internal", "Internal")}
          />
          <FormControlLabel
            value={DoubleMaterialityStakeholderType.External}
            control={<Radio disabled={disabled} />}
            label={t("stakeholders.fields.type.external", "External")}
          />
        </RadioGroup>
        {error && (
          <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
            {error.message}
          </Typography>
        )}
      </FormControl>
    )}
  />
);

export default StakeholderTypeField;
